import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import API from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        await API.post("/auth/google/session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        const u = await refresh();
        navigate(u && u.onboarded === false ? "/onboarding" : "/", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#EEF1F7] flex items-center justify-center" data-testid="auth-callback">
      <p className="font-serif text-2xl text-[#141A3A]">Accesso in corso…</p>
    </div>
  );
}
